import { PrintDataEntitas } from "@/domain/entities/Booking";
import jsPDF from "jspdf";

export const originDestinationV3 = (
  params: {
    doc: jsPDF | any;
    startX: number;
    startY: number;
    data: PrintDataEntitas;
  },
  coor: {
    startX: number;
    startY: number;
  }
) => {
  const xShift = -2;
  params.doc.setFont("Inter", "extrabold");
  params.doc.setTextColor("#333333");
  params.doc.setFontSize(14);
  params.doc.text(
    params.data.sttOriginCityId,
    coor.startX + 78 + xShift,
    coor.startY + 7
  );

  params.doc.setFont("Inter", "extrabold");
  params.doc.setTextColor("#333333");
  params.doc.setFontSize(28);
  params.doc.text(
    params.data.sttDestinationCityId,
    coor.startX + 78 + xShift,
    coor.startY + 17
  );

  // line after origin destination
  params.doc.setLineWidth(0.4);
  params.doc.line(
    coor.startX + 77 + xShift,
    coor.startY + 20,
    coor.startX + 108 + xShift,
    coor.startY + 20
  );
};
